import { ElementBuilder } from "@universityofmaryland/web-builder-library";
import "@universityofmaryland/web-styles-library";
import { createLayoutImageContainer } from "../../../layout/image.js";
import "@universityofmaryland/web-token-library";
const CreateMediaInline = (props) => (() => {
  const { image } = props;
  const createImage = () => {
    if (!image) {
      console.warn("CreateMediaInline: No image provided");
      return null;
    }
    return createLayoutImageContainer({ image, showCaption: true });
  };
  const imageElement = createImage();
  const model = new ElementBuilder().withClassName("element-media-inline-container").withStyles({
    element: {
      display: "block",
      maxWidth: "100%"
    }
  }).withChild(imageElement).build();
  return model;
})();
const createCompositeMediaInlineStandard = CreateMediaInline;
export {
  createCompositeMediaInlineStandard
};
//# sourceMappingURL=standard.js.map
